import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { fetchReportCsv } from '../../services/api';

export default function ReportExportButton({ path, filters, filename }) {
  const [busy, setBusy] = useState(false);

  const handle = async () => {
    setBusy(true);
    try {
      const blob = await fetchReportCsv(path, filters);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'report.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error('Export failed', e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      size="small"
      variant="outlined"
      onClick={handle}
      disabled={busy}
      startIcon={busy ? <CircularProgress size={14} /> : <FileDownloadOutlinedIcon fontSize="small" />}
    >
      Export CSV
    </Button>
  );
}
